import ApiUrl from "../../../configTools/api";
const User = JSON.parse(localStorage.getItem("user-info"));

// duedate is load-bearing, not decoration: the API derives the statement's period year from
// it and uses it as the upper bound of the rolling payments window. Omitting it (a legacy
// bookmarked URL) makes the API fall back to calendar-month behaviour.
const Get = (doctor,month,duedate,setValues) => {
    const params = new URLSearchParams({ doctor, month });
    if (duedate) params.set('duedate', duedate);
    fetch(ApiUrl.LabAdminPrint_Jobcard_BillingDetailed+"?"+params.toString(),{
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer '+User.token
        }
    })
    .then(res=>res.json())
    .then(data =>{
        console.log(data);
        setValues(data.response);
    });
}

const Functions = {Get};
export default Functions;